import "./single-cooperative.scss";
import "sticky-kit/dist/sticky-kit";
import "../../../js/core";
import Collapse from "bootstrap/js/src/collapse";
import { stickySidebar } from "../../../js/sticky-sidebar";
import "../../../../assets/src/eos/js/scroll-to-anchor";

// Expanded
$(function () {
  function ExpandListItem() {
    $(".list-item").each(function (index) {
      var $textBlock = $(this).find(".list-content > .inner").height();
      var $contentBlock = $(this).find(".list-content").height();

      if ($textBlock > $contentBlock) {
        $(this).addClass("show-btn");
      } else {
        $(this).removeClass("show-btn");
      }
    });
  }

  ExpandListItem();
  $(window).on("resize", function () {
    ExpandListItem();
  });

  $(".list-item")
    .find(".btn-list")
    .on("click", function (e) {
      e.preventDefault();
      $(this).parent(".list-item.show-btn").toggleClass("expanded");
    });

  $("body").on("click", "#view-more", function (e) {
    e.preventDefault();
    $(".list-wrap_more .list-item:hidden").slice(0).slideDown();
    ExpandListItem();
    if ($(".list-wrap_more .list-item:hidden").length == 0) {
      $("#view-more").css("visibility", "hidden");
    }
  });

  $(".list-item")
    .find(".btn-link")
    .on("click", function (e) {
      e.preventDefault();
      $(this).parent(".list-item.show-btn").toggleClass("expanded");
    });
});

// Popup link
$(function () {
  $("a.show").on("click", function (e) {
    var url = window.location.href;
    var tempInput = document.createElement("input");

    tempInput.style = "position: absolute; left: -1000px; top: -1000px";
    tempInput.value = url;
    document.body.appendChild(tempInput);
    tempInput.select();
    tempInput.setSelectionRange(0, 99999);
    document.execCommand("copy");
    document.body.removeChild(tempInput);

    $(this).next().fadeIn(500).fadeOut(3000);
  });
});

// Stiky function

stickySidebar(134);

// Collapse close
$(document).ready(function () {
  $(".accordion-button.less").on("click", function () {
    let closeTargetCollapse = $(this).data("bs-target");
    console.log(closeTargetCollapse);
    $(closeTargetCollapse).collapse("hide");
  });
});

// social links script
$(".social_link").click(function (event) {
  event.preventDefault();

  let url = $(this).attr("href");
  if (url != "#") {
    let width = 600;
    let height = 500;
    let left = (screen.width - width) / 2;
    let top = (screen.height - height) / 2;

    window.open(
      url,
      "",
      "width=" + width + ",height=" + height + ",left=" + left + ",top=" + top
    );
  }
});
